import { Box, Icon, ListItemIcon } from '@mui/material'
import { styled } from '@mui/material/styles'
import { colors } from '@resiliatech/birdsong'

import { ListItem, ListItemText } from '@material-ui/core'

export const TaskListMenuIcon = styled(Icon)`
  color: ${colors.copy.paragraphDark};
  min-width: 0 !important;
`

export const TaskMenuItemContainer = styled(Box)`
  color: ${colors.copy.paragraphDark};
  cursor: pointer;
  font-size: 16px;
  height: auto;
`

export const TaskMenuItemIcon = styled(ListItemIcon)`
  color: ${colors.interactive.primaryEnabled};
  width: 32px;
  min-width: 0 !important;
`

export const TaskMenuListItem = styled(ListItem)`
  align-items: center;
  display: flex;
  padding-right: 16px;
  justify-content: space-between;
`

export const TaskMenuItemText = styled(ListItemText)`
  font-size: 16px;
`

export const AddResourceDisabledIcon = () => (
  <svg
    width='25'
    height='19'
    viewBox='0 0 25 19'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M19.25 8.58333V5.33333H16V4.25H19.25V1H20.3333V4.25H23.5833V5.33333H20.3333V8.58333H19.25Z'
      fill='#BDBDBD'
      stroke='#BDBDBD'
    />
    <path
      d='M16.3636 15.6667V9.91667L9 14L0 9L9 4L18 9V15.6667H16.3636ZM9 19L3.27273 15.8333V11.6667L9 14.8333L14.7273 11.6667V15.8333L9 19Z'
      fill='#BDBDBD'
    />
  </svg>
)

export const AddResourceIcon = () => (
  <svg
    width='25'
    height='19'
    viewBox='0 0 25 19'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M19.7363 8.58333V5.33333H16.4863V4.25H19.7363V1H20.8197V4.25H24.0697V5.33333H20.8197V8.58333H19.7363Z'
      fill='#003F7E'
      stroke='#003F7E'
    />
    <path
      d='M16.85 15.6667V9.91667L9.48633 14L0.486328 9L9.48633 4L18.4863 9V15.6667H16.85ZM9.48633 19L3.75906 15.8333V11.6667L9.48633 14.8333L15.2136 11.6667V15.8333L9.48633 19Z'
      fill='#003F7E'
    />
  </svg>
)

export const RemoveResourceIcon = () => (
  <svg
    width='25'
    height='16'
    viewBox='0 0 25 16'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M15.75 2.33333V2.58333H16H19.25H23.5833H23.8333V2.33333V1.25V1H23.5833H19.25H19.1266H16H15.75V1.25V2.33333Z'
      fill='#003F7E'
      stroke='#003F7E'
      strokeWidth='0.5'
    />
    <path
      d='M16.3636 12.6667V6.91667L9 11L0 6L9 1L18 6V12.6667H16.3636ZM9 16L3.27273 12.8333V8.66667L9 11.8333L14.7273 8.66667V12.8333L9 16Z'
      fill='#003F7E'
    />
  </svg>
)
